import React, { useCallback, useEffect, useState } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import { playSound, SOUNDS } from '../utils/audio';
import './PublicLibrary.css';

const PublicLibrary = ({ onSelectSet }) => {
  const [sets, setSets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchPublicSets = useCallback(async () => {
    setLoading(true);
    setError('');

    try {
      const publicSetsQuery = query(
        collection(db, 'publicSets'),
        where('isPublished', '==', true)
      );
      const snapshot = await getDocs(publicSetsQuery);
      setSets(snapshot.docs
        .map(doc => ({
          id: doc.id,
          isPublic: true,
          ...doc.data()
        }))
        .sort((a, b) => (a.order || 0) - (b.order || 0)));
    } catch (fetchError) {
      console.error('Error fetching public sets:', fetchError);
      setError('Unable to load built-in sets');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPublicSets();
  }, [fetchPublicSets]);

  const handlePractice = (set) => {
    playSound(SOUNDS.TAP);
    onSelectSet([{
      id: set.id,
      name: set.name,
      userId: 'public',
      isPublic: true,
      collectionName: set.collectionName
    }]);
  };

  return (
    <section className="public-library">
      <header className="library-header">
        <div>
          <h2>Built-in Sets</h2>
          <p>Practice curated character packs without adding them to your collections.</p>
        </div>
      </header>

      {loading && <div className="library-state">Loading...</div>}
      {error && <div className="library-state error">{error}</div>}
      {!loading && !error && sets.length === 0 && (
        <div className="library-state">No built-in sets are published yet.</div>
      )}

      <div className="library-list">
        {sets.map(set => (
          <button
            key={set.id}
            className="library-item"
            onClick={() => handlePractice(set)}
          >
            <span className="library-item-main">
              <span className="library-name">{set.name}</span>
              <span className="library-meta">
                {set.collectionName || 'Built-in'} · {set.characterCount || 20} cards
              </span>
            </span>
            <span className="library-action">Practice</span>
          </button>
        ))}
      </div>
    </section>
  );
};

export default PublicLibrary;
